import { Component, computed, effect, inject, ViewChild, ViewContainerRef } from '@angular/core';
import { BottomSheetDataService } from '../../services/bottom-sheet-data.service';
import { NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-bottom-sheet',
  standalone: true,
  imports: [NgClass, MatIconModule],
  templateUrl: './bottom-sheet.component.html',
  styleUrl: './bottom-sheet.component.scss',
})
export class BottomSheetComponent {
  @ViewChild('bottomSheetRef', { read: ViewContainerRef, static: true }) bottomSheetRef!: ViewContainerRef;

  private _bottomSheetDataService = inject(BottomSheetDataService);

  protected bottomSheetExpandedState = computed(() => this._bottomSheetDataService.bottomSheetExpandedState());
  protected bottomSheetUiConfigState = computed(() => this._bottomSheetDataService.bottomSheetUiConfig());

  constructor() {
    effect(() => {
      this.bottomSheetRef?.clear();
      if (this.bottomSheetUiConfigState()?.contentComponent) {
        const componentRef = this.bottomSheetRef?.createComponent(this.bottomSheetUiConfigState().contentComponent);
        componentRef.location.nativeElement.classList.add('bottom-sheet-content');
      }
    });
  }

  protected toggleBottomSheetState() {
    if (this.bottomSheetExpandedState() === 'maximized') {
      this._bottomSheetDataService.setBottomSheetExpandedState('minimized');
    } else {
      this._bottomSheetDataService.setBottomSheetExpandedState('maximized');
    }
  }

  protected onCloseBtnClick() {
    this._bottomSheetDataService.setBottomSheetExpandedState('hidden');
  }
}
